import { useEffect, useState } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import { __ } from '@wordpress/i18n';

const Block = ({ checkoutExtensionData }) => {
    const [fileName, setFileName] = useState('');
    const [file, setFile] = useState(null);

    const { setExtensionData } = checkoutExtensionData;

    // Function to upload file using Fetch API
    const uploadFile = async () => {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            
            try {
                const response = await fetch('/wp-json/custom/v1/file-upload', {
                    method: 'POST',
                    body: formData,
                });

                if (response.ok) {
                    const result = await response.json();
                    console.log('File uploaded successfully:', result);
                } else {
                    console.error('File upload failed:', response.statusText);
                }
            } catch (error) {
                console.error('File upload error:', error);
            }
        }
    };

    const checkoutStatus = useSelect((select) => {
        const CHECKOUT_STORE_KEY = window.wc && window.wc.wcBlocksData && window.wc.wcBlocksData.CHECKOUT_STORE_KEY;
        if (!CHECKOUT_STORE_KEY) {
            return 'idle';
        }
        const store = select(CHECKOUT_STORE_KEY);
        return store.getCheckoutStatus();
    }, []);

    useEffect(() => {
        setExtensionData('file-upload-checkout', 'file_name', fileName);
        if (checkoutStatus === 'complete' && file) {
            uploadFile();
        }
    }, [checkoutStatus]);

    return (
        <div className="file-upload-container" data-upload="true" aria-live="polite">
            <label htmlFor="file-upload-checkout">{ __('Upload your file:', 'file-upload-checkout') }</label>
            <input
                type="file"
                id="file-upload-checkout"
                accept=".pdf,.doc"
                onChange={event => {
                    setFileName(event.target.files[0].name);
                    setFile(event.target.files[0]);
                }}
            />
        </div>
    );
};

export default Block;
